exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".button, .button:focus {\n  font-weight: bold;\n  color: #f4f4f4;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  height: 4rem;\n  border-radius: 2px;\n  border: none;\n  outline: none;\n  padding: 0 2.5rem;\n  flex-shrink: 0; }\n\n.button.large {\n  font-size: 1.2em;\n  height: 4.8rem;\n  min-width: 17rem; }\n\n.button.shadow {\n  box-shadow: 0 6px 16px -5px rgba(0, 0, 0, 0.5); }\n\n.button.extra-radius {\n  border-radius: 4px; }\n\n.button.transparent {\n  background: transparent;\n  color: #231f20; }\n\n.button.red {\n  background: #ef3d42; }\n\n.button.purple {\n  background: #8b3187; }\n\n.button.black {\n  background: #231f20; }\n\n.button.disabled {\n  color: #5d5555;\n  background: #f4f4f4;\n  pointer-events: none;\n  cursor: not-allowed; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/Shared/Button/Button.scss
// module id = 1440
// module chunks = 0